<template>
  <div class="selectInvoice">
    <div class="save" @click="save">选择</div>
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="itemWrap" v-for="(item, index) in data" :key="index">
          <div class="left">
            <van-checkbox
              v-model="item.checked"
              shape="square"
              checked-color="rgb(58, 117, 197)"
            ></van-checkbox>
          </div>
          <div :class="{ item: true, active: item.checked }" v-if="$route.name == 'selectInvoice'">
            <div>
              <div class="title">{{ item.buyerName }}</div>
              <div>{{ item.invoiceNumber }}</div>
              <div class="text">上传时间:{{ item.createTime }}</div>
            </div>
            <div style="text-align: right">
              <div class="title">￥{{ item.totalAmount }}</div>
              <div>{{ item.invoiceTypeName }}</div>
              <div class="nobx" v-show="item.status">已报销</div>
              <div class="text" v-show="!item.status">未报销</div>
            </div>
          </div>
          <div :class="{ item: true, active: item.checked }" v-if="$route.name == 'selectJzd'">
            <div>
              <div class="title">{{ item.applyNum}}</div>
              <div>借支金额:{{ item.applyAmountStr }}</div>
              <div>剩余未冲销金额:{{item.remainAmountStr}}</div>
              <div>费用说明:{{item.costDescription}}</div>
            </div>
            <div style="text-align: right">
              <div class="text">{{ item.borrowTypeName }}</div>
              <div class="text">{{ item.createUser }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="btnBox noCopy" v-if="$route.name == 'selectInvoice'">
      <div>
        <van-button @click="upload" :loading="uploadLoading"
          ><svg-icon icon-class="whiteSc" class="sc"></svg-icon
          >上传发票</van-button
        >
      </div>
      <WxTest v-if="!isPc" @change="wxChangeClip"></WxTest>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import WxTest from "@/views/myItems/wxTest.vue";
export default {
  components: {
    WxTest,
  },
  created() {
    this.getData();
    function IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }
    this.isPc = IsPC()
    console.log(IsPC())
  },
  data() {
    return {
      isPc:"",  //是否pc端
      uploadLoading: false,
      checked: false,
      loading: false,
      finished: false,
      total: 0,
      data: [],
      searchForm: {
        pageNum: 1,
        pageRows: 10,
      },
    };
  },
  destroyed() {
    this.$bus.$off("selectClip", () => {});
    this.$bus.$off("selectJzd", () => {});
  },
  methods: {
    wxChangeClip(clipList){
      this.$bus.$emit("selectClip", clipList);
      this.$router.go(-1);
    },
    onLoad() {
      this.searchForm.pageRows += 10;
      this.getData(this.searchForm);
    },
    save() {
      let arr = this.data.filter((item) => item.checked);
      if (!arr.length) {
        this.$toast({
          type: "fail",
          message: "请选择数据",
        });
        return;
      }
      if(this.$route.name === "selectInvoice"){this.$bus.$emit("selectClip", arr);}
      if(this.$route.name === "selectJzd"){this.$bus.$emit("selectJzd", arr);}
      this.$router.go(-1);
    },
    upload() {
      let a = document.createElement("input");
      a.type = "file";
      a.click();
      a.onchange = () => {
        // console.log("123")
        let params = new FormData();
        let arr = a.files[0].name.split(".");
        let str = arr[arr.length - 1];
        if (
          str != "jpg" &&
          str != "jpeg" &&
          str != "png" &&
          str != "pdf" &&
          str != "zip"
        ) {
          this.$toast.fail("仅支持上传jpg,jpeg,png,pdf,zip文件");
          // this.show = false;
          return;
        }
        params.append("file", a.files[0], a.files[0].name);
        params.append("detailUpload", "true");
        this.uploadLoading = true;
        this.$api
          .uploadPost(
            `/payment/center/invoiceClip/ocr/invoicesDiscern?token=${Cookies.get(
              "payapp_token"
            )}`,
            params
          )
          .then((res) => {
            if (res.repCode == "0000") {
              this.$toast({
                type: "success",
                message: "上传成功",
              });
              this.getData();
              if (res.repData.length) {
                this.$bus.$emit("selectClip", res.repData);
                this.$router.go(-1);
              }
            }
            this.uploadLoading = false;
          })
          .catch(() => {
            this.uploadLoading = false;
          });
      };
    },
    getData() {
      let path = ""
      if(this.$route.name == "selectJzd"){
        path = "/payment/center/reimburse/selectLoanList"
      }
      if(this.$route.name == "selectInvoice"){
        path="/payment/center/invoiceClip/clipList"
      }
      this.$api
        .post(path, {
          reqData: {
            ...this.searchForm,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            if(this.$route.name == "selectInvoice"){
              this.data = res.repData.result.map((item) => {
                return {
                  ...item,
                  checked: false,
                };
              });
            }
            if(this.$route.name == "selectJzd"){
              this.data = res.repData.list.map((item) => {
                return {
                  ...item,
                  checked: false,
                };
              });
            }
            this.total = res.repData.total;
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.selectInvoice {
  height: 100%;
  display: flex;
  flex-direction: column;
  .save {
    font-size: 14px;
    position: absolute;
    top: 12px;
    right: 20px;
    color: #1989fa;
    z-index: 100;
  }
  .wrap {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
  }
  .itemWrap {
    display: flex;
    align-items: center;
  }
  .item {
    flex: 1;
    margin-left: 20px;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 16px 24px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .title {
      color: rgb(44, 44, 44);
      margin-top: 4px;
      margin-bottom: 4px;
      // font-weight: bold;
      // font-family:"Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu;
    }
    .nobx {
      color: rgb(60, 119, 198);
    }
  }
  .item.active {
    border: 1px solid rgb(60, 119, 198);
    box-shadow: 0 0 0 0;
  }
  .btnBox {
    padding: 10px 20px;
    background: #fff;
    display: flex;
    >div{
      flex: 1;
    }
    >div:nth-child(1){
      padding-right:10px;
    }
    >div:nth-child(2){
      padding-left:10px;
    }
    button {
      width: 100%;
      border-radius: 5px;
      background: rgb(58, 117, 197);
      font-size: 12px;
      color: #fff;
      .sc {
        font-size: 12px;
        margin-right: 6px;
        color: #fff;
      }
    }
  }
}
</style>